<form [formGroup]="form.formGroup">
  <div class="flex flex-col space-y-2">
 
    <app-uom-input
      label="Loss Depth"
      [unitLabel]="userUnits.longLengths + ' MD'"
      [formControlName]="form.formControlNames.lossDepth"
      [control]="'lossDepth'"
      [default]="influxDepthRange.max"
      [min]="influxDepthRange.min"
      [max]="influxDepthRange.max"
      title="Allowed range: {{ influxDepthRange.min }} - {{ influxDepthRange.max }} {{ userUnits.longLengths }}"
      (focusout)="lossDepthChange()"
    />

    <app-uom-input
      label="Fluid Density"
      [unitLabel]="densityLabel"
      [formControlName]="form.formControlNames.fluidDensity"
      [control]="'fluidDensity'"
      [default]="nextStringMudWeight"
      [min]="densityValidation.min"
      [max]="densityValidation.max"
      title="Allowed range: {{ densityValidation.min }} - {{ densityValidation.max }} {{ densityLabel }}"
    />

    <app-uom-input
      label="Pore Pressure"
      [unitLabel]="densityLabel"
      [formControlName]="form.formControlNames.porePressure"
      [control]="'porePressure'"
      [min]="porePressureValidation.min"
      [max]="porePressureValidation.max"
      title="Allowed range: {{ porePressureValidation.min }} - {{ porePressureValidation.max }} {{ densityLabel }}"
      (focusout)="porePressureChange()"
    />

    <app-uom-input
      label="Margin of Error"
      [unitLabel]="densityLabel"
      [formControlName]="form.formControlNames.marginOfError"
      [control]="'marginOfError'"
      [default]="'0'"
      [min]="marginOfErrorValidation.min"
      [max]="marginOfErrorValidation.max"
      title="Allowed range: {{ marginOfErrorValidation.min }} - {{ marginOfErrorValidation.max }} {{ densityLabel }}"
    />
  </div>
</form>
